import { createRoot } from 'react-dom/client'
import { Suspense } from 'react'
import { Provider } from 'react-redux'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import store from './redux/store'
import App from './App'
import { globalStyles } from '@raskrask-dk/rr-components'
import './i18n'
import { ProviderBFSM } from './contexts/bfsmContext'
import { ProviderServiceCombinations } from './contexts/serviceCombinationsContext'

import TagManager from 'react-gtm-module'
import { hotjar } from 'react-hotjar'
import ReactPixel from 'react-facebook-pixel'

const tagManagerArgs = {
    gtmId: 'GTM-TBHBQGC',
}

TagManager.initialize(tagManagerArgs)
hotjar.initialize(1657642, 6, false)
ReactPixel.init('1388759814483497')
ReactPixel.pageView()

globalStyles()

const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript

root.render(
    <ProviderBFSM>
        <ProviderServiceCombinations>
            <Provider store={store}>
                <Suspense fallback={<>Loading...</>}>
                    <BrowserRouter>
                        <Routes>
                            {['/', '/:flow', '/:flow/:bookingId'].map(
                                (path) => (
                                    <Route
                                        key={path}
                                        path={path}
                                        element={<App />}
                                    />
                                )
                            )}
                        </Routes>
                    </BrowserRouter>
                </Suspense>
            </Provider>
        </ProviderServiceCombinations>
    </ProviderBFSM>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
